import AppointmentsList from './AppointmentsList';

export default AppointmentsList;
